/* MOVEA — interacciones (vanilla JS, un solo archivo para todas las páginas) */
(function () {
  if (window.__mvInit) return;
  window.__mvInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Aparición al hacer scroll + contadores ---------- */
  var io = null;
  function observe(root) {
    var els = (root || document).querySelectorAll('.mv-reveal:not(.mv-visible), [data-mv-count]:not([data-done])');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('mv-visible'); if (el.hasAttribute('data-mv-count')) finishCount(el); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var el = e.target;
          el.classList.add('mv-visible');
          if (el.hasAttribute('data-mv-count')) countUp(el);
          io.unobserve(el);
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { io.observe(el); });
  }
  function parseNum(t) { return parseFloat(String(t).replace(',', '.')); }
  function fmt(n, dec) { return n.toFixed(dec).replace('.', ','); }
  function finishCount(el) { el.setAttribute('data-done', '1'); }
  function countUp(el) {
    var raw = el.getAttribute('data-mv-count');
    var target = parseNum(raw);
    if (isNaN(target)) return finishCount(el);
    var dec = (raw.split(/[.,]/)[1] || '').length;
    var dur = 1400, start = null;
    el.setAttribute('data-done', '1');
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(target * eased, dec);
      if (p < 1) requestAnimationFrame(step); else el.textContent = raw;
    }
    requestAnimationFrame(step);
  }

  /* ---------- Brillo que sigue al cursor en tarjetas ---------- */
  function initCards(root) {
    (root || document).querySelectorAll('.mv-card').forEach(function (c) {
      if (c.__mv) return; c.__mv = 1;
      c.addEventListener('pointermove', function (e) {
        var r = c.getBoundingClientRect();
        c.style.setProperty('--x', (e.clientX - r.left) + 'px');
        c.style.setProperty('--y', (e.clientY - r.top) + 'px');
      });
    });
  }

  /* ---------- Carrusel de zonas ---------- */
  function initZonas(root) {
    (root || document).querySelectorAll('[data-mv-zonas]').forEach(function (w) {
      if (w.__mv) return; w.__mv = 1;
      var track = w.querySelector('.mv-zonas__track');
      if (!track) return;
      w.querySelectorAll('[data-dir]').forEach(function (b) {
        b.addEventListener('click', function () {
          var card = track.querySelector('.mv-zona');
          var d = card ? card.getBoundingClientRect().width + 18 : 300;
          track.scrollBy({ left: d * parseInt(b.getAttribute('data-dir'), 10), behavior: 'smooth' });
        });
      });
    });
  }

  /* ---------- Selector de colores de la portada ---------- */
  function initColores(root) {
    (root || document).querySelectorAll('[data-mv-colores]').forEach(function (w) {
      if (w.__mv) return; w.__mv = 1;
      var imgs = w.querySelectorAll('.mv-colores__stage img');
      var label = w.querySelector('.mv-colores__label');
      var btns = w.querySelectorAll('.mv-swatch');
      btns.forEach(function (b, i) {
        b.addEventListener('click', function () {
          btns.forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-pressed', 'false'); });
          imgs.forEach(function (x) { x.classList.remove('is-active'); });
          b.classList.add('is-active'); b.setAttribute('aria-pressed', 'true');
          if (imgs[i]) imgs[i].classList.add('is-active');
          if (label) label.textContent = b.getAttribute('data-name');
        });
      });
    });
  }

  /* ---------- Página de producto ---------- */
  function money(cents, format) {
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    var withDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    if (!format) return withComma + ' €';
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount\s*\}\}/, withDot);
  }

  function initPDP(root) {
    (root || document).querySelectorAll('[data-mv-pdp]').forEach(function (w) {
      if (w.__mv) return; w.__mv = 1;
      var dataEl = w.querySelector('[data-mv-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var fmtEl = w.querySelector('[data-mv-money]');
      var moneyFmt = fmtEl ? JSON.parse(fmtEl.textContent) : null;
      var form = w.querySelector('form[action*="/cart/add"]');
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var priceEl = w.querySelector('[data-mv-price]');
      var compareEl = w.querySelector('[data-mv-compare]');
      var saveEl = w.querySelector('[data-mv-save]');
      var addBtn = w.querySelector('[data-mv-add]');
      var addLabel = addBtn ? addBtn.querySelector('span') : null;
      var txtAdd = addBtn ? addBtn.getAttribute('data-add') : '';
      var txtSold = addBtn ? addBtn.getAttribute('data-sold') : '';
      var mainImg = w.querySelector('[data-mv-main]');
      var thumbs = w.querySelectorAll('.mv-thumb');
      var msg = w.querySelector('.mv-buy__msg');
      var stickyPrice = document.querySelector('[data-mv-sticky-price]');

      function showImage(src, srcset, idx) {
        if (!mainImg || !src) return;
        mainImg.style.opacity = 0;
        setTimeout(function () {
          mainImg.removeAttribute('srcset');
          mainImg.src = src; if (srcset) mainImg.srcset = srcset;
          mainImg.style.opacity = 1;
        }, 160);
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        if (idx != null && thumbs[idx]) thumbs[idx].classList.add('is-active');
      }
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () { showImage(t.getAttribute('data-src'), t.getAttribute('data-srcset'), i); });
      });

      function selected() {
        var vals = [];
        w.querySelectorAll('.mv-option').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          vals.push(c ? c.value : null);
        });
        return vals;
      }
      function update() {
        var vals = selected();
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === vals[i]; }); });
        w.querySelectorAll('.mv-option').forEach(function (fs, i) {
          var c = fs.querySelector('input:checked');
          var out = fs.querySelector('legend b');
          if (c && out) out.textContent = c.getAttribute('data-label') || c.value;
        });
        if (!v) {
          if (addBtn) { addBtn.disabled = true; if (addLabel) addLabel.textContent = txtSold; }
          return;
        }
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price, moneyFmt);
        if (stickyPrice) stickyPrice.textContent = money(v.price, moneyFmt);
        if (compareEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            compareEl.textContent = money(v.compare_at_price, moneyFmt); compareEl.hidden = false;
            if (saveEl) { saveEl.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%'; saveEl.hidden = false; }
          } else { compareEl.hidden = true; if (saveEl) saveEl.hidden = true; }
        }
        if (addBtn) {
          addBtn.disabled = !v.available;
          if (addLabel) addLabel.textContent = v.available ? txtAdd : txtSold;
        }
        if (v.featured_image) {
          var idx = null;
          thumbs.forEach(function (t, i) { if (t.getAttribute('data-id') == v.featured_media_id) idx = i; });
          showImage(v.featured_image.src, '', idx);
        }
        if (window.history && window.history.replaceState) {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u.toString());
        }
      }
      w.querySelectorAll('.mv-option input').forEach(function (i) { i.addEventListener('change', update); });

      var qty = w.querySelector('.mv-qty input');
      w.querySelectorAll('.mv-qty button').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = parseInt(qty.value, 10) || 1;
          n = Math.max(1, n + parseInt(b.getAttribute('data-step'), 10));
          qty.value = n;
        });
      });

      if (form && window.fetch) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (addBtn) { addBtn.disabled = true; addBtn.classList.add('is-loading'); }
          if (msg) msg.textContent = '';
          var fd = new FormData(form);
          fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST', headers: { 'Accept': 'application/json' }, body: fd
          })
            .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
            .then(function (res) {
              if (!res.ok) throw new Error(res.j.description || res.j.message || 'Error');
              window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
            })
            .catch(function (err) {
              if (msg) msg.textContent = err.message;
              if (addBtn) { addBtn.disabled = false; addBtn.classList.remove('is-loading'); }
            });
        });
      }

      var sticky = document.querySelector('.mv-sticky-buy');
      if (sticky && addBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          en.forEach(function (e) { sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0); });
        }).observe(addBtn);
        var sb = sticky.querySelector('button');
        if (sb) sb.addEventListener('click', function () {
          addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
    });
  }

  function initAll(root) {
    observe(root); initCards(root); initZonas(root); initColores(root); initPDP(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  /* Editor de Shopify: re-inicializar al editar secciones */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
